/* JS is now deactivated in this project, use .ts files instead */

import { register } from "../../../JavaScript/Utils";

export const NavigationToggle = (el: HTMLElement) => {
  const navigationElements = el.querySelectorAll(".navigation-element");
  const toggleClass: HTMLElement = el.querySelector(".nav--toggle");

  // toggle class mobile navigation
  toggleClass.addEventListener("click", (e: MouseEvent) => {
    (<HTMLElement>e.currentTarget).classList.toggle("is--active");
  });

  navigationElements.forEach((navigationElements) => {
    const toggleIcon: HTMLElement =
      navigationElements.querySelector(".toggle-icon");
    const navigationElementContainer: HTMLElement =
      navigationElements.querySelector(".navigation-element-container");
    if (toggleIcon)
      toggleIcon.addEventListener("click", () => {
        if (navigationElementContainer.classList.contains("active")) {
          navigationElementContainer.classList.remove("active");
        } else {
          navigationElementContainer.classList.add("active");
        }
      });
  });
};

register("NavigationToggle", NavigationToggle);
